import { formatProductCard, type RGProduct } from "@raumagarn/formatters";
import {
	getAccessoryCategory,
	getRecipeGarmentType,
	getRecipeYarnType,
	getSearchTitle,
	getSkuRank,
} from "./utils";

export const formatAlgoliaProductCard = (product: RGProduct) => {
	const productCard = formatProductCard(product);
	const productType = product.pr_product_type_type;

	const recipeYarnType = getRecipeYarnType(product);
	const recipeGarmentType = getRecipeGarmentType(product);
	const accessoryCategory = getAccessoryCategory(product);

	const priceForRanking = productCard.pricelist?.[0]?.priceAsNumber || 0;

	return {
		displayItemId: productCard.displayItemId,
		name: productCard.name,
		searchTitle: getSearchTitle(productCard.name),
		uri: productCard.uri,
		gallery: productCard.gallery,
		price: productCard.price,
		priceBeforeDiscount: productCard.priceBeforeDiscount,
		sku: productCard.sku,
		fits: productCard.fits,
		cannonicalCategory: productCard.cannonicalCategory,
		productType,
		priceForRanking,
		pricelist: productCard.pricelist,
		skuRank: getSkuRank(product),
		productSku: product.productSku,
		yarnType: productCard.yarnType,
		yarnLengthAndWeight: productCard.yarnLengthAndWeight,
		yarnOptionLength: productCard.yarnOptionLength,
		yarnMaterials: productCard.yarnMaterials,
		recipeYarnType: recipeYarnType,
		recipeGarmentType: recipeGarmentType,
		recipeFits: product.pr_fits,
		recipeDifficulty: product.pr_recipe_difficulty_value,
		recipeTechniques: product.pr_techniques,
		recipeLanguage: product.pr_language,
		knittingGauge: product.pr_knitting_gauge,
		knittingDirection: product.pr_knitting_direction_value,
		needleSize: product.pr_needle_size,
		...accessoryCategory,
		accessoryNeedleSize: product.var_needle_size,
		freeRecipe: productCard.freeRecipe,
		isFreeRecipe: productCard.productType === "recipe" && productCard.freeRecipe.length > 0,
		archive: productCard.archive,
		isArchive: productCard.archive.length > 0,
		outlet: productCard.outlet,
		isOutlet: productCard.outlet.length > 0,
		comingSoon: productCard.comingSoon,
		showAsNew: productCard.showAsNew,
		showAsOnSale: productCard.showAsOnSale,
		categories: product.categoryName,
		priceAsNumber: productCard?.priceAsNumber,
		priceBeforeDiscountAsNumber: productCard?.priceBeforeDiscountAsNumber,
		variantName: productCard?.variantName,
		newVariantColor: productCard.newVariantColor,
		isNew: productCard.isNew,
		theme: product.pr_theme,
		yoke: product.pr_yoke,
		shoulderType: product.pr_type_shoulder,
		structure: product.pr_structure,
		formFit: product.pr_form_fit,
		neck: product.pr_neck,
	};
};

export type AlgoliaProductCard = ReturnType<typeof formatAlgoliaProductCard> & {
	objectID: string;
	relation: undefined;
	media: undefined;
};

export * from "./article";
export * from "./fetchers";
